import { motion } from "framer-motion";
import { Sparkle } from "lucide-react";

export function Marquee({ items }) {
  const strip = (ariaHidden) => (
    <div className="flex shrink-0 items-center" aria-hidden={ariaHidden}>
      {items.map((it, i) => (
        <span key={i} className="flex items-center">
          <span className="font-cinzel text-sm sm:text-base tracking-[0.3em] uppercase px-8 whitespace-nowrap">{it}</span>
          <Sparkle size={14} className="text-[#F59E0B] shrink-0" />
        </span>
      ))}
    </div>
  );
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden bg-maroon text-[#FDF3E3] py-4">
      <div className="flex w-max animate-marquee">
        {strip(false)}
        {strip(true)}
      </div>
    </div>
  );
}

export function Reveal({ children, delay = 0, y = 28, className = "", ...rest }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function Stagger({ children, className = "" }) {
  return (
    <motion.div
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.12 }}
      variants={{ hidden: {}, show: { transition: { staggerChildren: 0.12 } } }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function StaggerItem({ children, className = "" }) {
  return (
    <motion.div
      variants={{ hidden: { opacity: 0, y: 26 }, show: { opacity: 1, y: 0, transition: { duration: 0.65, ease: [0.22, 1, 0.36, 1] } } }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function Eyebrow({ children, center = false }) {
  return (
    <p className={`text-xs uppercase font-mono tracking-[0.3em] text-saffron font-semibold ${center ? "text-center" : ""}`}>
      {children}
    </p>
  );
}

export function SectionHeading({ eyebrow, title, sub, center = true }) {
  return (
    <Reveal className={center ? "text-center" : ""}>
      {eyebrow && <Eyebrow center={center}>{eyebrow}</Eyebrow>}
      <h2
        data-testid="section-heading"
        className="font-display text-3xl sm:text-4xl lg:text-[44px] font-semibold text-maroon leading-[1.12] mt-3"
      >
        {title}
      </h2>
      {sub && <p className={`text-[#6B5D52] mt-4 max-w-2xl leading-relaxed ${center ? "mx-auto" : ""}`}>{sub}</p>}
    </Reveal>
  );
}
